import React, { useEffect, useState, useContext, useRef } from 'react'

import MapContext from './MapContext'
import MeteoIcon from '../../icons/meteo.svg'


const RadarControl = (props) => {
  const [isActive, setIsActive] = useState(false)
  const [apiData, setApiData] = useState(false)
  const [time, setTime] = useState(false)
  const timeout = useRef()
  const map = useContext(MapContext)
  const cls = "button circular fa " + ((isActive) ? "active secondary pulse" : "basic")

  useEffect(() => {
    fetch("https://api.rainviewer.com/public/weather-maps.json")
      .then(res => res.json())
      .then(apiData => {
        setApiData(apiData)
      })
  }, [])

  useEffect(() => {
    if (!map || !apiData) return

    apiData.radar.nowcast.forEach(frame => {
      map.addLayer({
        id: `rainviewer_${frame.path}`,
        type: "raster",
        source: {
          type: "raster",
          volatile: true,
          tiles: [
            apiData.host + frame.path + '/256/{z}/{x}/{y}/2/1_1.png'
          ],
          tileSize: 256
        },
        layout: { 
          visibility: "none" 
        },
        paint: {
            'raster-opacity': .8,
            'raster-fade-duration': 0
        },
        minzoom: 0,
        maxzoom: 12
      }, map.getStyle().layers[50].id)
    })

    return () => {
      if (!map || !apiData || map._removed) return
      clearTimeout(timeout.current)
      apiData.radar.nowcast.forEach((frame, index) => {
        map.removeLayer(`rainviewer_${frame.path}`)
      })
    }

  }, [map, apiData])

  useEffect(() => {
    if (!map || !apiData) return

    if (!isActive) {
      clearTimeout(timeout.current)
      apiData.radar.nowcast.forEach((frame, index) => {
        map.setLayoutProperty(
          `rainviewer_${frame.path}`,
          "visibility",
          "none"
        );
      });
      return
    }

    let i = 0;
    const updateLayer = () => {
      if (i > apiData.radar.nowcast.length - 1) {
        i = 0;
      } 
      apiData.radar.nowcast.forEach((frame, index) => {
        if (index===i){
          const date = new Date(frame.time * 1000)
          const minutes = "0" + date.getMinutes();
          setTime(`${date.getHours()}:${minutes.substr(-2)}`)
        }
        map.setLayoutProperty(
          `rainviewer_${frame.path}`,
          "visibility",
          index === i ? "visible" : "none"
        );
      });

      map.once('idle', function() {
        i ++
        timeout.current = setTimeout(updateLayer, 2000)
      });
    }

    updateLayer();

  }, [map, apiData, isActive])

  if (!apiData) return null

  return (
    <div className="radar">
      <button className={cls}
        onClick={() => setIsActive(!isActive)}>
        <MeteoIcon/>
      </button>
      { isActive && time && (
        <span>{time}</span>
      )}
    </div>
  )
}

export default RadarControl
